module.exports = __webpack_public_path__ + "img/image-builder.5a98cde6.jpg";